<template>
    <section class="blog_section" :style="'min-height:'+$minHeight+';'">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="container">
            <div class="blog_section_menu pt-2 pb-2">
                <ul class="nav justify-content-center">
                    <li class="nav-item" v-for="(row, index) in blogCategory" :key="index">
                        <a class="nav-link" title="Gadget Specs" href="javascript:void(0);"  @click="filterCategory(row.id)"> {{ row.name }} </a>
                    </li>
                </ul>
            </div>
            <div class="row" v-if="!categoryWiseBlog">
                <div class="col-md-4 p-2" v-for="(row, index) in blogList" :key="index">
                    <div class="p-4 border">
                        <div class="border-bottom mb-3 pb-3 px-2 d-flex justify-content-between">
                            <div class="d-flex align-items-center">
                                <router-link :to="{ name: 'BlogDetail', params: { id: row.id }}" style="color: #9B5DE5; font-size: 16px;" class="text-capitalize font-weight-bold mb-0"> {{ row.category_name }} </router-link>
                            </div>
                            <!-- <a href="#" class="text-dark">See All</a> -->
                        </div>
                        <div class="mb-3">
                            <img class="w-100 mb-3" v-bind:src="imagePath + row.image">
                            <!-- <div class="d-flex align-items-center">
                                <small style="color: #9B5DE5;">6 min ago</small>
                            </div> -->
                            <router-link :to="{ name: 'BlogDetail', params: { id: row.id }}" class="d-block text-dark my-1" style="font-size: 1.1rem; font-weight: 600;"> {{ row.title }} </router-link>
                            <small class="text-secondary" v-html="row.short_detail"></small>
                        </div>
                        <!-- <div class="d-flex align-items-start mb-3">
                            <img class="img-fluid mr-3" style="width: 110px;"
                                 src="https://cdn.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_220,h_150/https://8am.af/wp-content/uploads/2020/08/EgmZsngWAAIog-f-220x150.jpg"
                                 alt="">
                            <div>
                                <div class="d-flex align-items-center">

                                    <small style="color: #9B5DE5;">6 min ago</small>
                                </div>
                                <small><a href="###" class="text-dark" style="font-weight: 600; line-height:1;">Karzai
                                    supports Abdullah’s stance on formation of HCNR</a></small>
                            </div>
                        </div> -->
                        <!-- <div class="d-flex align-items-start mb-3">
                            <img class="img-fluid mr-3" style="width: 110px;"
                                 src="https://cdn.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_220,h_150/https://8am.af/wp-content/uploads/2020/08/118327748_727213428129352_7910082187282163488_n-220x150.jpg"
                                 alt="">
                            <div>
                                <div class="d-flex align-items-center">

                                    <small style="color: #9B5DE5;">6 min ago</small>
                                </div>
                                <small><a href="###" class="text-dark" style="font-weight: 600; line-height:1;">Karzai
                                    supports Abdullah’s stance on formation of HCNR</a></small>
                            </div>
                        </div> -->
                        <!-- <div class="d-flex align-items-start mb-3">
                            <img class="img-fluid mr-3" style="width: 110px;"
                                 src="https://cdn.shortpixel.ai/client/q_glossy,ret_img,w_600/https://8am.af/wp-content/uploads/2019/06/wezarat-dakhila-600x400.jpg"
                                 alt="">
                            <div>
                                <div class="d-flex align-items-center">

                                    <small style="color: #9B5DE5;">6 min ago</small>
                                </div>
                                <small><a href="###" class="text-dark" style="font-weight: 600; line-height:1;">Karzai
                                    supports Abdullah’s stance on formation of HCNR</a></small>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="row" v-if="categoryWiseBlog">
                <div class="col-md-4 p-2"  v-for="(row, index) in categoryWiseBlogList[0].blogData" :key="index">
                    <div class="p-4 border">
                        <div class="border-bottom mb-3 pb-3 px-2 d-flex justify-content-between">
                            <div class="d-flex align-items-center">
                                <router-link :to="{ name: 'BlogDetail', params: { id: row.id }}" style="color: #9B5DE5; font-size: 16px;" class="text-capitalize font-weight-bold mb-0"> {{ categoryWiseBlogList[0].category_name }} </router-link>
                            </div>
                            <!-- <a href="#" class="text-dark">See All</a> -->
                        </div>
                        <div class="mb-3">
                            <img v-bind:src="imagePath + row.image">
                            <!-- <div class="d-flex align-items-center">
                                <small style="color: #9B5DE5;"> 6 min ago </small>
                            </div> -->
                            <router-link :to="{ name: 'BlogDetail', params: { id: row.id } }" class="d-block text-dark my-1" style="font-size: 1.1rem; font-weight: 600;"> {{ row.title }} </router-link>
                            <small class="text-secondary" v-html="row.short_detail"></small>
                        </div>
                        <!-- <div class="d-flex align-items-start mb-3">
                            <img class="img-fluid mr-3" style="width: 110px;"
                                 src="https://cdn.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_220,h_150/https://8am.af/wp-content/uploads/2020/08/EgmZsngWAAIog-f-220x150.jpg"
                                 alt="">
                            <div>
                                <div class="d-flex align-items-center">

                                    <small style="color: #9B5DE5;">6 min ago</small>
                                </div>
                                <small><a href="###" class="text-dark" style="font-weight: 600; line-height:1;">Karzai
                                    supports Abdullah’s stance on formation of HCNR</a></small>
                            </div>
                        </div> -->
                        <!-- <div class="d-flex align-items-start mb-3">
                            <img class="img-fluid mr-3" style="width: 110px;"
                                 src="https://cdn.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_220,h_150/https://8am.af/wp-content/uploads/2020/08/118327748_727213428129352_7910082187282163488_n-220x150.jpg"
                                 alt="">
                            <div>
                                <div class="d-flex align-items-center">

                                    <small style="color: #9B5DE5;">6 min ago</small>
                                </div>
                                <small><a href="###" class="text-dark" style="font-weight: 600; line-height:1;">Karzai
                                    supports Abdullah’s stance on formation of HCNR</a></small>
                            </div>
                        </div> -->
                        <!-- <div class="d-flex align-items-start mb-3">
                            <img class="img-fluid mr-3" style="width: 110px;"
                                 src="https://cdn.shortpixel.ai/client/q_glossy,ret_img,w_600/https://8am.af/wp-content/uploads/2019/06/wezarat-dakhila-600x400.jpg"
                                 alt="">
                            <div>
                                <div class="d-flex align-items-center">

                                    <small style="color: #9B5DE5;">6 min ago</small>
                                </div>
                                <small><a href="###" class="text-dark" style="font-weight: 600; line-height:1;">Karzai
                                    supports Abdullah’s stance on formation of HCNR</a></small>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "Blog",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            blogCategory: [],
            blogList: [],
            categoryWiseBlogList: [],
            imagePath: this.$api + "upload/blog/",
            categoryWiseBlog: false
        }
    },
    created() {
        this.getBlogCategory();
        this.getBlogList();
    },
    mounted(){
        var pageHeight=window.innerHeight-390;
        this.$minHeight=pageHeight+"px";
    },
    methods: {
        getBlogCategory: function() {
            this.isLoading = true;
            this.$axios.get(this.$api + "api/geek-blog-category").then(response => {
                if(response.data.status == "success") {
                    this.blogCategory = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            })
        },
        getBlogList: function() {
            this.isLoading = true;
            this.$axios.get(this.$api + "api/geek-blog-list").then(response => {
                if(response.data.status == "success") {
                    this.blogList = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        filterCategory: function(id) {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + "api/geek-blog-category-wise-list/" + id,
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.categoryWiseBlogList = response.data.data;
                    this.categoryWiseBlog = true;
                }
                this.isLoading = false;
            })
            .catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
        }
    }
}
</script>
